import React, {
    useCallback, useContext, useState, useEffect
} from 'react'
import { Formik, Form } from 'formik'
import { FaLock, FaUser } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import ReactTooltip from 'react-tooltip'

import { api } from '../../services/api'
import history from '../../services/history'
import Yup from '../../services/yup'

import { criptografar } from '../../util/crypto'
import scroll from '../../util/scroll'

import { GlobalContext } from '../../contexts/GlobalContext'

import { Textbox, Button, List } from '../../components/Form'

import { Container, Content, LoginsContainer } from './styles'
import useQuery from '../../hooks/useQuery'

const validation = Yup.object({
    crm: Yup.string().required('Informe o CPF.'),
    senha: Yup.string().required('Senha obrigatória.')
})

const baseInitialValues = {
    crm: '',
    senha: ''
}

export default function SignIn() {
    scroll.toTop()

    const searchParams = useQuery()

    const { setUser, clienteRobot } = useContext(GlobalContext)

    const [initialValues, setInitialValues] = useState(baseInitialValues)
    const [login, setLogin] = useState({
        crm: '',
        senha: ''
    })
    const [crm, setCrm] = useState('')

    const handleSubmit = useCallback(async (values, { setSubmitting }) => {
        try {
            const body = {
                ...values,
                crm: Number(values.crm) || 0
            }

            const session = await api.post('sessao', body)

            if (session.usuario.associado?.status_associacao.id === 6) {
                session.usuario.perfil.grupos = session.usuario.perfil.grupos.filter(g => [2, 24].includes(g.id))
            }

            setUser(session.usuario)

            const ciphed = criptografar(JSON.stringify(session.usuario))

            sessionStorage.setItem(process.env.REACT_APP_SESSION_STORAGE_TOKEN, session.token)
            sessionStorage.setItem(process.env.REACT_APP_SESSION_STORAGE_USER, ciphed)

            setSubmitting(false)

            if(searchParams?.projeto) {
                history.push(`/projeto/${searchParams.projeto}`)
            } else {
                history.push('/dashboard')
            }
        } catch (e) {
            console.log(e)

            toast.error(e.msg || e)
        }
    }, [])

    useEffect(() => {
        setInitialValues(login)
        setCrm(login.crm)
    }, [login])

    useEffect(() => {
        const storedLogin = JSON.parse(localStorage.getItem('gestaonamao_admin'))

        if (storedLogin) {
            setLogin({
                ...storedLogin,
                hasStoredLogin: true
            })
        }
    }, [])

    const predefinedUserList = [
        { label: !!process.env.REACT_APP_ADMIN_PREDEFINED_LOGIN ? 'Admin' : 'Luiza Lobo (testador)', value: 'admin basico' }
    ]

    if (process.env.REACT_APP_ENVIRONMENT !== '') {
        predefinedUserList.push({ label: 'Jacirema (autora)', value: 'autor' })
        predefinedUserList.push({ label: 'Francisca (participante)', value: 'usuario comum' })
    }

    return (
        <>
            <Container>
                <div className="space" style={{ width: '100%' }} />

                <Content className="animated fadeInUp faster delay-300ms">
                    <img src={clienteRobot?.logo_square} alt={clienteRobot?.name} />

                    <Formik
                        initialValues={initialValues}
                        validationSchema={validation}
                        onSubmit={handleSubmit}
                        enableReinitialize
                    >
                        {({ isSubmitting }) => (
                            <Form>
                                <h1>Login</h1>

                                <Textbox
                                    name="crm"
                                    label="Identificação do usuário"
                                    onChange={e => {
                                        setCrm(e.target.value)
                                        setLogin({
                                            crm: e.target.value,
                                            senha: login.senha
                                        })
                                    }}
                                    value={crm}
                                    icon={{ source: FaUser, size: 18 }}
                                />

                                <Textbox name="senha" type="password" label="Senha" autocomplete="on" icon={{ source: FaLock, size: 16 }} disableSubmitWithEnter={false} />

                                <Button type="submit" loading={isSubmitting} className="transparent">Entrar</Button>

                                <p>ou</p>

                                <Link to="/pass_recover">Esqueci a senha</Link>

                            </Form>
                        )}
                    </Formik>
                </Content>

                {process.env.REACT_APP_ENVIRONMENT !== '' && (
                    <LoginsContainer className="animated fadeInRight faster delay-500ms">
                        <h1>Logins predefinidos</h1>

                        <p>{`Ambiente: ${process.env.REACT_APP_ENVIRONMENT}`}</p>

                        <List
                            options={predefinedUserList}
                            onChange={e => {
                                switch (e.value) {
                                    case 'admin basico':
                                        setLogin({
                                            crm: '999',
                                            senha: '22222222222'
                                        })
                                        break

                                    case 'autor':
                                        setLogin({
                                            crm: '69887859060',
                                            senha: '22222222222'
                                        })
                                        break

                                    case 'usuario comum':
                                        setLogin({
                                            crm: '46061134053',
                                            senha: '46061134053'
                                        })
                                        break

                                    case 'representante empresa':
                                        setLogin({
                                            crm: '09510',
                                            senha: '0951009510'
                                        })
                                        break

                                    default: break
                                }
                            }}
                        />
                    </LoginsContainer>
                )}
            </Container>

            <ReactTooltip
                place="top"
                effect="solid"
                type="dark"
            />
        </>
    )
}
